 <template>
  <div
      ref="self"
      data-dusk="sub-tab-group"
      :class="[ 'sub-tab-group', orientation ]"
      :style="{ width: orientation === 'vertical' ?  220 + 'px' : 'auto' }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "SubTabGroup.vue",
  emits: ['input'],
  props: {
    orientation: {
      required: false,
      default: 'horizontal',
      validate(value) {
        return value === 'vertical' || value === 'horizontal';
      }
    },
    multiSelect: {
      required: false,
      default: false,
      type: Boolean,
    },
    value: {
      required: false,
      type: [String, Number],
    },
    id: {
      type: [String, Number],
      required: false,
    },

  },
  mounted() {
    this.$nextTick(() => {
      if (this.id) {
        this.contentWrapper = document.querySelector('.sub-tab-content-wrapper#' +  this.id);
      } else {
        // If no id passed select first that is found.
        this.contentWrapper = document.getElementsByClassName('sub-tab-content-wrapper')[0];
      }

      this.initializeTabs();
      if (this.tabContents.length === 0) {
        const observer = new MutationObserver(this.initializeTabs);
        observer.observe(this.contentWrapper, {
          childList: true,
          subtree: true,
        });
      }
    })
  },
  beforeUnmount() {
    for(let i= 0; i< this.subTabs.length; i++) {
      this.subTabs[i].removeEventListener('click');
    }
  },
  methods: {
    initializeTabs() {
      let self = this.$refs.self;
      this.subTabs = self.getElementsByClassName('sub-tab');
      this.tabContents = this.contentWrapper.getElementsByClassName('sub-tab-content');
      if (this.tabContents.length === 0) return;
      for(let i = 0; i < this.subTabs.length; i++) {
        this.subTabs[i].addEventListener('click', () => this.onTabClick(i) );
      }
      if (!this.multiSelect) this.onTabClick(this.activeContentIndex);
      if (this.multiSelect) this.initializeActiveTabs();
    },
    onTabClick(index) {
      if (!this.tabContentExists(index)) return;

      if(this.multiSelect) this.handleMultiSelect(index);
      else {
        this.handleSingleSelect(index);
      }
    },
    initializeActiveTabs() {
      for(let i = 0; i < this.tabContents.length; i++) {
        if (this.subTabs[i].classList.contains('active') &&  this.tabContents[i].classList.contains('active')) this.activeTabs.push(i);
      }
    },
    handleMultiSelect(index) {
      if (this.activeTabs.includes(index)) {
        this.activeTabs.splice(this.activeTabs.findIndex((tab) => tab === index), 1);
      } else {
        this.activeTabs.push(index);
      }
      this.resetSubTabClasses();
      this.resetTabContentClasses();
      // Apply appropriate styling
      for (const [arrayIndex, tabIndex] of this.activeTabs.entries()) {
        this.subTabs[tabIndex].classList.add('active');

        // Order items based on recent clickiness.
        this.tabContents[tabIndex].style.order = this.activeTabs.length - 1 - arrayIndex;
        this.tabContents[tabIndex].classList.add('active');
      }
    },
    emitActiveTabKey() {
      if (this.tabContents[this.activeTabIndex].hasAttribute('id')) {
        const activeKey = this.tabContents[this.activeTabIndex].getAttribute('id');
        this.$emit('input', activeKey);
      }
    },
    handleSingleSelect(index) {
      this.activeContentIndex = index;
      this.setActiveContent();
      this.setActiveSubTab();
    },
    resetTabContentClasses() {
      for(let i = 0; i < this.tabContents.length; i++) {
        this.tabContents[i].classList.remove('active');
      }
    },
    resetSubTabClasses() {
      for(let i = 0; i < this.subTabs.length; i++) {
        this.subTabs[i].classList.remove('active');
      }
    },
    setActiveContent() {
      this.resetTabContentClasses();
      this.tabContents[this.activeContentIndex].classList.add('active');
    },
    setActiveSubTab() {
      this.resetSubTabClasses();
      this.subTabs[this.activeContentIndex].classList.add('active');
    },
    tabContentExists(i) {
      return !!this.tabContents[i];
    }
  },

  data() {
    return {
      subTabs: null,
      activeContentIndex: 0,
      activeTabs: [],
      tabContents: null,
      contentWrapper: null,
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.sub-tab-group {
  display: flex;
  flex-direction: column;
  gap: $spacing-md;
}
.horizontal {
  flex-direction: row;
  overflow-x: auto;
  scrollbar-width: thin;
  padding-bottom: 6px;

  >.sub-tab{
    white-space: nowrap;
  }
}
.vertical {
  flex-direction: column;
}
</style>

<style lang="scss" >
@import "~@/_default.scss";
.sub-tab-content-wrapper {
  .sub-tab-content {
    display: none;
    width: 100%;
  }
  .sub-tab-content.active {
    display: inherit;
  }
}
</style>
